import { useAppName, useLanguage, useSitecoreApiHost, useSitecoreApiKey } from '../../utils/sitecoreContext';
import { useGetColorByTransmissionQuery } from '../apis/layoutServiceApi';
const useFetchLayoutServiceTransmission = (transmissionId) => {
    const language = useLanguage();
    const appName = useAppName();
    const sitecoreApiHost = useSitecoreApiHost();
    const sitecoreApiKey = useSitecoreApiKey();
    const params = `sc_apikey=${sitecoreApiKey}&sc_site=${appName}&sc_lang=${language}`;
    const getUrl = (endpoint) => `${sitecoreApiHost || ''}${endpoint}?${params}`;
    const { data, isFetching, isLoading, error } = useGetColorByTransmissionQuery({ url: getUrl(`/dmmapi/trimandcolors/transmission/${transmissionId}`), transmissionId }, { skip: !transmissionId });
    return {
        data,
        isFetching,
        isLoading,
        error,
    };
};
export default useFetchLayoutServiceTransmission;
